import { flattenParsedApplicationResponseDetails } from '@common/services';

import { normalizeCoapplicantList } from './coapplicantCompatibility';

interface FormValue {
  [key: string]: any;
}
interface Data {
  applicationId: string;
  clientId: number;
  details: string;
  formId: string;
  id: string;
  primaryApplicationResponseId: string;
  relationshipType: string;
}

function normalizeCoapplicantFields(data: FormValue): FormValue {
  const coApplicant = data?.coApplicant;
  if (!coApplicant || typeof coApplicant !== 'object' || Array.isArray(coApplicant)) {
    return data;
  }

  return {
    ...data,
    coApplicant: {
      ...coApplicant,
      coApplicantList: normalizeCoapplicantList(coApplicant.coApplicantList),
    },
  };
}

export function prepareFormInitializingData(data: Data) {
  const parsedDetails = JSON.parse(data?.details);

  if (!Object.keys(parsedDetails).length) return {};
  const flattenedData = flattenParsedApplicationResponseDetails(parsedDetails) as FormValue;
  return normalizeCoapplicantFields(flattenedData);
}

export function prepareApplicantResponseData(data: any) {
  if (!Object.keys(data).length) return {};
  const flattenedData = flattenParsedApplicationResponseDetails(data) as FormValue;
  return normalizeCoapplicantFields(flattenedData);
}
